//TestView.vue



<template>

  <div>

	<div id="background">
		<h1 id="view-title">This page is only for development tests</h1>
		<!-- <img id="project-image" :src="'imgs/projects/snohetta.jpg'" /> -->
		<!-- <img id="project-image" :src="'imgs/projects/antwerpen1.jfif'" /> -->
		<!-- <img id="project-image" :src="'imgs/projects/dujardin.jpg'" /> -->
		<img id="project-image" :src="'imgs/projects/mainzerobg.jpg'" />
	</div>

	<div id="header">
		<HeaderBasic />
	</div>  

	<div v-if="showTest" id="button-predimension" class="button">
		<button @click="testPredimensionClick">
			Test Predimension
		</button>
	</div>

	<div v-if="showTest" id="button-member" class="button">
		<button @click="testMemberClick">
			Test Member
		</button>
	</div>

	<div id="button-log" class="button">
		<button  @click="logDistanceColumns">
			Log Columns
		</button>
	</div>

	<div id="button-dist-edge" class="button">
		<button @click="minimalDistanceColumnsOuterEdge">
			Delete minDist edge
		</button>
	</div>

	<div id="button-dist-inner" class="button">
		<button @click="minimalDistanceColumnsOuterInner">
			Delete minDist inner
		</button>
	</div>

	<div id="button-dist-core" class="button">
		<button @click="scaleCoreClicked">
			Scale core
		</button>
	</div>

	<div id="button-delete-core" class="button">
		<button @click="minimalDistanceCoreInnerColumnsClicked">
			Delete innnerCol within scaled core
		</button>
	</div>




	<!-- <div id="canvas-container">
		<canvas id="myCanvas"></canvas>
	</div> -->

  </div>

</template>




<script>

import HeaderBasic from "../components/HeaderBasic.vue";

import * as THREE from "three";

import * as StructuralMember from "../classes/StructuralMember.js";
import * as PreDimension from "../classes/PreDimension.js";
import * as MyFunctions from "../MyFunctions.js";
import * as BuildingResult from "../classes/BuildingResult.js";


const minColumnDistance = 10;
const minCoreDistance = 2.5;


var innerColumns = [
	new THREE.Vector3(25, 10, 0),
	new THREE.Vector3(25, 20, 0),
	new THREE.Vector3(25, 30, 0),
	new THREE.Vector3(25, 40, 0),
	new THREE.Vector3(50, 10, 0),
	new THREE.Vector3(50, 20, 0),
	new THREE.Vector3(50, 30, 0),
	new THREE.Vector3(50, 40, 0)
];

var outerColumns = [
	new THREE.Vector3(0, 10, 0),
	new THREE.Vector3(0, 20, 0),
	new THREE.Vector3(0, 30, 0),
	new THREE.Vector3(0, 40, 0),

	new THREE.Vector3(75, 10, 0),
	new THREE.Vector3(75, 20, 0),
	new THREE.Vector3(75, 30, 0),
	new THREE.Vector3(75, 40, 0),

	new THREE.Vector3(25, 0, 0),
	new THREE.Vector3(25, 48, 0),

	new THREE.Vector3(50, 0, 0),
	new THREE.Vector3(50, 45, 0)
];

var edgeColumns = [
	new THREE.Vector3(0, 0, 0),
	new THREE.Vector3(75, 0, 0),
	new THREE.Vector3(0, 50, 0),
	new THREE.Vector3(75, 42, 0)
];

var corePts1 = [
	new THREE.Vector3(26, 15, 0),
	new THREE.Vector3(26, 35, 0),
	new THREE.Vector3(30, 15, 0),
	new THREE.Vector3(30, 35, 0)
];

var corePts2 = [
	new THREE.Vector3(51, 15, 0),
	new THREE.Vector3(51, 35, 0),
	new THREE.Vector3(60, 15, 0),
	new THREE.Vector3(60, 35, 0)
];

var cores = [
	corePts1, 
	corePts2
];


export default {
	components: {
		HeaderBasic,
	},
	methods: {
		testPredimensionClick() {

			// const material = "Concrete";
			// var structSystem = "Beam";
			// structSystem = "Plate";
			// const story = 2;
			// const load = 5;                 //kN/m2
			// const spanX = 6;
			// const spanY = 8;


			//Slab test

			//Default Building Geometry
			// var pts = [];
			// var pt1 = new THREE.Vector3(-25, -30, 0);
			// var pt2 = new THREE.Vector3(-25, 40, 0);
			// var pt3 = new THREE.Vector3(10, 40, 0);
			// var pt4 = new THREE.Vector3(10 ,20, 0);
			// var pt5 = new THREE.Vector3(-5, 20, 0);
			// var pt6 = new THREE.Vector3(-5, -10, 0);
			// var pt7 = new THREE.Vector3(15, -10, 0);
			// var pt8 = new THREE.Vector3(15, -30, 0);

			// pts = [pt1, pt2, pt3, pt4, pt5, pt6, pt7, pt8, pt1];


			// const material = "Steel";
			// const structSystem = "Plate";


			//PreDimension
			//--------------------------------------------------------------------------------

			//Slab
			// var slabResult = PreDimension.predimSlab(material, structSystem, 5, 6, 3.6, 3);
			// console.log(slabResult);
			//Beam 
			// var beam = new StructuralMember.Beam(new THREE.Vector3(0,0,0), new THREE.Vector3(0,8,0), material, "Secondary", 2, 5);
			// console.log(beam);
			// var beamResult = PreDimension.predimBeam(beam, material, 5, beam.length, 5, 6, 3.5, structSystem, 0.2);
			// console.log(beamResult);
			// var beamResult = PreDimension.predimCompositeSteelBeam(5, beam.length, 5, beam.length, 3.5);
			// console.log(beamResult);

			//Column 
			// var columnResult = PreDimension.predimColumn(material, structSystem, 1200, 3.4);
			// console.log(columnResult);


			//New timber beam
			// var load = 5;
			// var length = 6;
			// var distance =  5;



			// function predimCLTSlab(spanX, spanY, liveLoad, deadLoad)
			// var result = TempDimension.predimCLTSlab(6, 4, 4.2, 1.3);
			// console.log(result);

			// function predimRibbedTimberSlab(spanX, spanY, liveLoad, deadLoad)
			// var result = TempDimension.predimRibbedTimberSlab(8, 7, 3.2, 1.9);
			// console.log(result);

			// function predimHBVSlab(spanX, spanY, liveLoad, deadLoad)
			// var result = TempDimension.predimHBVSlab(8, 7, 3.2, 1.4);
			// console.log(result);


			// var result = TempDimension.predimTimberColumn(3400, 4.4)
			// console.log(result);





			//Carbon
			//--------------------------------------------------------------------------------

			//Slab
			// var slabCarbon = BuildingResult.calculateCarbonForSlab(material, slabResult, structSystem);
			// console.log(slabCarbon);
			//Beam
			// var beamCarbon = BuildingResult.calculateCarbonForBeam(material, structSystem, beamResult);
			// console.log(beamCarbon);
			//Column
			// var columnCarbon = BuildingResult.calculateCarbonForColumn(material, structSystem, columnResult);
			// console.log(columnCarbon);



			//Costs
			//--------------------------------------------------------------------------------

			//Slab
			// var slabCost = BuildingResult.calculateCostsForSlab(material, slabResult, structSystem);
			// console.log(slabCost);
			//Beam
			// var beamCost = BuildingResult.calculateCarbonForBeam(material, structSystem, beamResult);
			// console.log(beamCost);
			//Column
			// var columnCost = BuildingResult.calculateCarbonForColumn(material, structSystem, columnResult);
			// console.log(columnCost);



			//Weight
			//--------------------------------------------------------------------------------

			//Slab
			// var slabWeight = BuildingResult.calculateWeightForSlab(material, slabResult, structSystem);
			// console.log(slabWeight);
			//Beam
			// var beamWeight = BuildingResult.calculateWeightForBeam(material, structSystem, beamResult);
			// console.log(beamWeight);
			//Column
			// var columnWeight = BuildingResult.calculateWeightForColumn(material, structSystem, columnResult);
			// console.log(columnWeight);
		},
		testMemberClick() {
		},
		logDistanceColumns() {
			console.log('innerColumns: ');
			console.log(innerColumns);

			console.log('outerColumns: ');
			console.log(outerColumns);

			console.log('edgeColumns: ');
			console.log(edgeColumns);

			console.log('cores: ');
			console.log(cores);
		},
		minimalDistanceColumnsOuterEdge() {

			console.log('minimalDistanceColumnsOuterEdge clicked');

			for (let i = 0; i < outerColumns.length; i++) {		
				for (let j = 0; j < edgeColumns.length; j++) {
					var line = new THREE.Line3(outerColumns[i], edgeColumns[j]);
					var dist = line.distance();
					if (dist < minColumnDistance ) {
						outerColumns.splice(i, 1);
					}
				}	
			}

			console.log('outerColumns after minimalDistanceColumnsOuterEdge: ');
			console.log(outerColumns);
		},
		minimalDistanceColumnsOuterInner() {

			console.log('minimalDistanceColumnsOuterInner clicked');

			for (let i = 0; i < outerColumns.length; i++) {		
				for (let j = 0; j < innerColumns.length; j++) {
					var line = new THREE.Line3(outerColumns[i], innerColumns[j]);
					var dist = line.distance();
					if (dist < minColumnDistance ) {
						outerColumns.splice(i, 1);
					}
				}	
			}

			console.log('outerColumns after minimalDistanceColumnsOuterInner clicked: ');
			console.log(outerColumns);
		},
		minimalDistanceCoreInnerColumnsClicked() {
			this.minimalDistanceCoreInnerColumns(cores);
		},
		minimalDistanceCoreInnerColumns(cores) {

			console.log('innerColumns: ');
			console.log(innerColumns);

			var indicesToRemove = [];

			for (let i = 0; i < cores.length; i++) {

				var scaledCorePts = this.scaleCore(cores[i], minCoreDistance);

				console.log('scaledCorePts');
				console.log(scaledCorePts);

				// Delete innerColumns within minDistance
				for (let i = 0; i < innerColumns.length; i++) {
					if(innerColumns[i].x > scaledCorePts[0] && innerColumns[i].x < scaledCorePts[1]) {
						if(innerColumns[i].y > scaledCorePts[2] && innerColumns[i].y < scaledCorePts[3]) {
							console.log('innerColumns within core');
							console.log(innerColumns[i]);
							indicesToRemove.push(i);
							// innerColumns.splice(i, 1);
						}
					}		
				}
			}

			console.log('indicesToRemove: ');
			console.log(indicesToRemove);


			//TO DO!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!111

			for (let i = 0; i < indicesToRemove.length; i++) {
				innerColumns.splice(indicesToRemove[i], 1);
			}

			console.log('innerColumns after minimalDistanceCoreInnerColumns: ');
			console.log(innerColumns);
		},
		scaleCore(corePts, minDistance) {

			//Min/Max Values
			var minX;
			var minY;
			var maxX;
			var maxY;

			//Scale core
			for (let i = 0; i < corePts.length - 1; i++) {
				//Minimum
				if(corePts[i].x < corePts[i+1].x) {
					minX = corePts[i].x;
				}
				if(corePts[i].y <= corePts[i+1].y) {
					minY = corePts[i].y;
				}
				//Maximum
				if(corePts[i].x >= corePts[i+1].x) {
					maxX = corePts[i].x;
				}	
				if(corePts[i].y >= corePts[i+1].y) {
					maxY = corePts[i].y;
				}
			}

			// console.log('minX: ');
			// console.log(minX);
			// console.log('minY: ');
			// console.log(minY);

			// console.log('maxX: ');
			// console.log(maxX);
			// console.log('maxY: ');
			// console.log(maxY);

			//Scaled values
			var scaledMinX = minX - minDistance;
			var scaledMinY = minY - minDistance;
			var scaledMaxX = maxX + minDistance;
			var scaledMaxY = maxY + minDistance;

			var scaledPts = [scaledMinX, scaledMaxX, scaledMinY,scaledMaxY];

			return scaledPts;
		},
		scaleCoreClicked() {
			for (let i = 0; i < cores.length; i++) {
				this.scaleCore(cores[i], minCoreDistance);
			}
		},
		makeGradient() {
		},
		clickLoaded() {
		},
		makeGradientColor() {
			var c = document.getElementById("gradient-canvas");
			var ctx = c.getContext("2d");

			this.$store.state.ctx = ctx;
		
			// console.log(ctx);	
		},
	},
	data() {
		return {
			cores: [],
			buildingOutline: '',
			showTest: false
		};
	},
	mounted() {
		// var c = document.getElementById("myCanvas");
		// var ctx = c.getContext("2d");

		// // Create gradient
		// //---------------------------------------------------------------
		
		// //Gradient Purple
		// var gradientPurple = ctx.createLinearGradient(0, 0, 0, 150);
		// gradientPurple.addColorStop(0, '#5555FF');	//dark
		// gradientPurple.addColorStop(1, '#9787FF');	//light

		// //Gradient Blue
		// var gradientBlue = ctx.createLinearGradient(0, 0, 0, 150);
		// gradientBlue.addColorStop(0, '#1563bd');
		// gradientBlue.addColorStop(1, '#538ccf');

		// //Gradient Green
		// var greenGradient = ctx.createLinearGradient(0, 0, 0, 150);
		// greenGradient.addColorStop(0, '#537a37');
		// greenGradient.addColorStop(1, '#95bf77');

		// //Gradient Dark Green
		// var darkGreenGradient = ctx.createLinearGradient(0, 0, 0, 100);
		// darkGreenGradient.addColorStop(0, '#264a0d');
		// darkGreenGradient.addColorStop(1, '#72915c');

		// //Gradient Red
		// var redGradient = ctx.createLinearGradient(0, 0, 0, 150);
		// redGradient.addColorStop(0, '#ff3636');
		// redGradient.addColorStop(1, '#ff7575');

		// //Gradient Orange
		// var orangeGradient = ctx.createLinearGradient(0, 0, 0, 150);
		// orangeGradient.addColorStop(0, '#ed8e3b');
		// orangeGradient.addColorStop(1, '#f5ae71');

		// //Gradient Black
		// var blackGradient = ctx.createLinearGradient(0, 0, 0, 150);
		// blackGradient.addColorStop(0, '#1c1c1c');
		// blackGradient.addColorStop(1, '#4d4b4b');

		// //Gradient Dark Grey
		// var darkGreyGradient = ctx.createLinearGradient(0, 0, 0, 150);
		// darkGreyGradient.addColorStop(0, '#4d4d4d');
		// darkGreyGradient.addColorStop(1, '#7a7a7a');

		// //Gradient Light Grey
		// var lightGreyGradient = ctx.createLinearGradient(0, 0, 0, 150);
		// lightGreyGradient.addColorStop(0, '#7a7a7a');
		// lightGreyGradient.addColorStop(1, '#c4c4c4');

		// //Gradient Brown
		// var brownGradient = ctx.createLinearGradient(0, 0, 0, 150);
		// brownGradient.addColorStop(0, '#452b0c');
		// brownGradient.addColorStop(1, '#59452d');

		// //Gradient White
		// var whiteGradient = ctx.createLinearGradient(0, 0, 0, 100);
		// whiteGradient.addColorStop(0, '#c7c7c7');
		// whiteGradient.addColorStop(1, '#f5f5f5');

		// // Fill with gradient
		// ctx.fillStyle = darkGreenGradient;
		// ctx.fillRect(0, 0, 200, 200);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


#canvas-container {
	position: fixed;
	top: 20%;
	left: 40%;
	height: 400px;
	width: 400px;
	border: 1px solid black;
	padding: 20px;
}


#myCanvas {
	height: 200px;
	width: 200px;
	border: 1px solid black;
}

#test-chart-container {
	height: 400px;
	width: 400px;
	/* border: 1px solid black; */
	position: fixed;
	top: 20%;
	left: 40%;
	padding: 10px;
}

#chart {
	padding: 30px;
	height: 300px;
	width: 300px;
	/* border: 1px solid black; */
}

#background {
	top: 0;
	left: 0;
	height: 100vh;
	width: 100vw;
	background: rgba(145, 145, 145, 0.2);
	position: absolute;
	background-image: linear-gradient(rgba(220, 220, 222, 1),rgba(194, 194, 207, 0.8));
}

#view-title {
	top:10%;
	left: 10%;
	position: fixed;
	color: black;
	font-family: Roboto;
	font-weight: 200;
	text-align: left;
	margin-left: 30px;
	padding-top: 20px;
	opacity: 0;
}

#project-image {
	height: 100vh;
	top: 0%;
	left: 0%;
	position: fixed;
	opacity: .1;
}

#header {
	position: fixed;
	top: 2%;
}

#test-input-bar {
	position: fixed;
	top: 10%;
	left: 0%;
	z-index: 100;
}

#test-result-bar {
	position: fixed;
	top: 10%;
	right: 0%;
	z-index: 100;
}

#input-bar-test {
	position: fixed;
	top: 14%;
	left: 30%;
}

.button {
	height: 200px;
	width: 200px;
}

#button-predimension {
	position: fixed;
	top: 20%;
	left: 10%;
}

#button-member {
	position: fixed;
	top: 25%;
	left: 10%;
}

#button-log {
	position: fixed;
	top: 30%;
	left: 10%;
}

#button-dist-edge {
	position: fixed;
	top: 35%;
	left: 10%;
}

#button-dist-inner {
	position: fixed;
	top: 40%;
	left: 10%;
}

#button-dist-core {
	position: fixed;
	top: 45%;
	left: 10%;
}

#button-delete-core {
	position: fixed;
	top: 50%;
	left: 10%;
}



#input-container{
	position: fixed;
	top: 35%;
	left: 10%;
}

#loader-wrapper {
	position: fixed;
	top: 85%;
	left: 45%;
}

</style>












